<div class="main-container">
  <div [formGroup]="deviceOTAForm" novalidate>
    <div class="page-header">
      <div class="routing-buttons">
        <!-- (click)="navigateBack()" -->
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
      </div>

      <span class="page-title">View/Update Device OTA Batch</span>
    </div>

    @if (viewOta) {
      <div class="component-container">
        <!-- Component Header Section -->
        <div class="component-header">
          <h6 class="component-title">Batch Details</h6>
          <div class="component-actions"></div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="" class="form-label">Batch Id</label>
              <mat-form-field class="form-group" appearance="outline">
                <mat-label>Batch Id</mat-label>
                <input
                  matInput
                  readonly
                  placeholder="OTA Batch Id"
                  [value]="OtaBatchId"
                />
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="batchDescription" class="form-label"
                >OTA Batch Name</label
              >
              <mat-form-field class="form-group" appearance="outline">
                <mat-label>OTA Batch Name</mat-label>
                <input
                  matInput
                  readonly
                  placeholder="OTA Batch Name"
                  [value]="OtaBatchName"
                />
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="" class="form-label">OTA Batch Description</label>
              <mat-form-field class="form-group" appearance="outline">
                <mat-label>OTA Batch Description</mat-label>
                <input
                  matInput
                  readonly
                  placeholder="OTA Batch Description *"
                  [value]="OtaBatchDescription"
                />
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="batchDescription" class="form-label"
                >OTA Batch Date</label
              >
              <mat-form-field class="form-group" appearance="outline">
                <mat-label>OTA Batch Date</mat-label>
                <input
                  matInput
                  readonly
                  placeholder="OTA Batch Date *"
                  [value]="OtaBatchDate"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="kpi-section">
        <div
          class="kpi-card kpi-gradient-blue"
          (click)="scrollTo('')"
          tabindex="0"
          (keydown.enter)="scrollTo('')"
        >
          <div class="kpi-details">
            <span class="kpi-content">Total Uploaded Devices</span>
            <span class="kpi-value">
              {{ totalUploaded }}
            </span>
          </div>
          <div class="kpi-visual">
            <img loading="lazy" src="../../assets/uploaded.png" alt="device" />
          </div>
        </div>
        <div
          class="kpi-card kpi-gradient-yellow"
          (click)="scrollTo('P')"
          tabindex="0"
          (keydown.enter)="scrollTo('P')"
        >
          <div class="kpi-details">
            <span class="kpi-content">Total Pending Devices</span>
            <span class="kpi-value">{{ totalPending }}</span>
          </div>
          <div class="kpi-visual">
            <img loading="lazy" src="../../assets/pending.png" alt="quality" />
          </div>
        </div>
        <div
          class="kpi-card kpi-gradient-purple"
          (click)="scrollTo('I')"
          tabindex="0"
          (keydown.enter)="scrollTo('I')"
        >
          <div class="kpi-details">
            <span class="kpi-content">Total Initiated Devices</span>
            <span class="kpi-value">
              {{ totalInitiated }}
            </span>
          </div>
          <div class="kpi-visual">
            <img loading="lazy" src="../../assets/initiated.png" alt="device" />
          </div>
        </div>
        <div
          class="kpi-card kpi-gradient-orange"
          (click)="scrollTo('IP')"
          tabindex="0"
          (keydown.enter)="scrollTo('IP')"
        >
          <div class="kpi-details">
            <span class="kpi-content">Total In-Progress Devices</span>
            <span class="kpi-value">
              {{ totalInProgress }}
            </span>
          </div>
          <div class="kpi-visual">
            <img
              loading="lazy"
              src="../../assets/in-progress.png"
              alt="device"
            />
          </div>
        </div>
        <div
          class="kpi-card kpi-gradient-pink"
          (click)="scrollTo('A')"
          tabindex="0"
          (keydown.enter)="scrollTo('A')"
        >
          <div class="kpi-details">
            <span class="kpi-content">Total Aborted Devices</span>
            <span class="kpi-value">
              {{ totalAborted }}
            </span>
          </div>
          <div class="kpi-visual">
            <img loading="lazy" src="../../assets/aborted.png" alt="device" />
          </div>
        </div>
        <div
          class="kpi-card kpi-gradient-green"
          (click)="scrollTo('C')"
          tabindex="0"
          (keydown.enter)="scrollTo('C')"
        >
          <div class="kpi-details">
            <span class="kpi-content">Total Completed Devices</span>
            <span class="kpi-value">
              {{ totalCompleted }}
            </span>
          </div>
          <div class="kpi-visual">
            <img loading="lazy" src="../../assets/completed.png" alt="device" />
          </div>
        </div>
      </div>

      <div class="component-container">
        <!-- Component Header Section -->
        <div class="component-header">
          <h6 class="component-title">Device Details</h6>
          <div class="component-actions">
            <app-common-search
              (cleared)="onClear($event)"
              (searchSubmit)="onKeyUpEventBatchList($event)"
            ></app-common-search>
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>IMEI</th>
                <th>OTA Triggered</th>
                <th>OTA Response</th>
                <th>OTA Status</th>
                <th>Action</th>
              </tr>
            </thead>
            @if (deviceOtaList.length > 0) {
              <tbody>
                @for (configA of deviceOtaList; track configA) {
                  <tr>
                    <td>
                      {{ configA['imei'] || '--' }}
                    </td>
                    <td>
                      {{ configA['command'] || '--' }}
                    </td>
                    <td>
                      {{ configA['commandRes'] || '--' }}
                    </td>

                    <td
                      [ngClass]="{
                        green: configA['otaMsg'] === 'OTA completed',
                        red:
                          configA['otaMsg'] === 'OTA error' ||
                          configA['otaMsg'] === 'Batch aborted' ||
                          configA['otaMsg'] === 'Device not found' ||
                          configA['otaMsg'] === 'Command not found' ||
                          configA['otaMsg'] === 'Aborted',
                      }"
                    >
                      {{ configA['otaMsg'] || '--' }}
                    </td>
                    <td>
                      <div class="action-buttons">
                        @if (updateOta) {
                          <button
                            class="primary-button abort-button"
                            [disabled]="
                              configA['otaStatus'] === 'A' ||
                              configA['otaStatus'] === 'BA' ||
                              configA['otaStatus'] === 'C' ||
                              configA['otaStatus'] === 'DNFD'
                            "
                            (click)="abort(configA['id'])"
                          >
                            <mat-icon class="btn-icon">block</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (deviceOtaList.length < 1) {
              <tbody>
                <tr>
                  <td colspan="12">
                    <img
                      loading="lazy"
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found."
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          <app-common-component-pagination
            *ngIf="deviceOtaList.length > 0"
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            [currentPage]="currentPage"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        </div>
      </div>
    }
  </div>
</div>
